import React from 'react'
import {getTicket,setTicket} from '../../utils/Session'
import { Redirect } from 'react-router-dom'
export const BASE_URL="https://" + window.location.hostname + "/exchange";
// export const BASE_URL="http://34.96.229.203:7070/trust";
export const HTTP_METHOD_GET = "get";
export const HTTP_METHOD_POST = "post";
export const HTTP_METHOD_PUT = "put";
export const HTTP_METHOD_DELETE = "delete";
export const RESPONSE_CODE_SUCCESS = "success";
export const RESPONSE_CODE_NOT_LOGIN = "login.user.not.login";

export const doGet = (that, uri, successCallBack, failCallBack) => {
    return httpRequest(that, BASE_URL + uri, HTTP_METHOD_GET, "", successCallBack, failCallBack);
};

export const doPost = (that, uri, body, successCallBack, failCallBack) => {
    return httpRequest(that, BASE_URL + uri, HTTP_METHOD_POST, JSON.stringify(body), successCallBack, failCallBack);
};

export const doUpload = (that, uri, body, successCallBack, failCallBack) => {
    let isOk;
    fetch(BASE_URL + uri, {
        method: 'post',
        body: body,
        headers: {
            'ticket': getTicket(),
        },
    }).then((response) => {
        if (response.ok) {
            isOk = true;
        } else {
            isOk = false;
        }
        return response.json();
    }).then((responseData) => {
        if (isOk) {
            if (typeof successCallBack === "function") {
                successCallBack(responseData);
            }
        } else {
            handleRequestFail(that, responseData);
            if (typeof failCallBack === "function") {
                failCallBack(responseData);
            }
        }
    });};

export const doPut = (that, uri, body, successCallBack, failCallBack) => {
    return httpRequest(that, BASE_URL + uri, HTTP_METHOD_PUT, JSON.stringify(body), successCallBack, failCallBack);
};

export const doDelete = (that, uri, body, successCallBack, failCallBack) => {
    return httpRequest(that, BASE_URL + uri, HTTP_METHOD_DELETE, JSON.stringify(body), successCallBack, failCallBack);
};

export const httpRequest = (that, url, method, body, successCallBack, failCallBack) => {
    let ticket = getTicket();
    let isOk;
    if(method==HTTP_METHOD_GET){
        var param = {
            method: method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Accept': 'application/json',
                'ticket': ticket,
                'connection': 'close',
            },
        };
    }else {
        var param = {
            method: method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Accept': 'application/json',
                'ticket': ticket,
                'connection': 'close',
            },
            body: body
        };
    }

    fetch(url, param).then((response) => {
        if (response.ok) {
            isOk = true;
        } else {
            isOk = false;
        }
        return response.json();
    }).then((responseData) => {
        if (isOk) {
            if (typeof successCallBack === "function") {
                successCallBack(responseData);
            }
        } else {
            handleRequestFail(that, responseData);
            if (typeof failCallBack === "function") {
                failCallBack(responseData);
            }
        }
    });
};

export const fileUpload = (that, url, formData, successCallBack, failCallBack) => {
    let ticket = getTicket();
    let isOk;
    var param = {
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data;charset=utf-8',
            'ticket': ticket,
            'connection': 'close',
        },
        body: formData
    };
    fetch(BASE_URL + url, param).then((response) => {
        if (response.ok) {
            isOk = true;
        } else {
            isOk = false;
        }
        return response.json();
    }).then((responseData) => {
        if (isOk) {
            if (typeof successCallBack === "function") {
                successCallBack(responseData);
            }
        } else {
            handleRequestFail(that, responseData);
            if (typeof failCallBack === "function") {
                failCallBack(responseData);
            }
        }
    }).catch( err => alert("出差了") ).done();
};
var copy=0
/**
 * 网络请求失败的时候一些公共的处理方法
 */
export const handleRequestFail = (that, responseData) => {
    if (RESPONSE_CODE_NOT_LOGIN == responseData.code) {
        if(copy==0){
            copy=1
            alert("登录超时了")
            that.props.history.replace("/login");
        }
    }
};




// WEBPACK FOOTER //
// ./src/components/DoFetch/doFetch.js